import { ID } from "@project/shared-types";
import { useContext, useMemo } from "react";
import { UserContext } from "./UserContext";

/**
 * Хук для получения ID пользователя из контекста
 * @returns {string | null} ID пользователя или null, если пользователь не авторизован
 */
export const useUserId = (): ID | null => {
  const context = useContext(UserContext);
  if (!context) {
    return null;
  }

  return useMemo(() => context.user?.id || null, [context.user]);
};
